module.exports = __webpack_public_path__ + "static/media/hamburger.d3a11ae2.svg";